import React, { useState, useEffect } from "react";
import { Link, NavLink } from "react-router-dom";
import axios from "axios";
import moment from "moment";
import Spinner from "react-bootstrap/Spinner";
import Monthly_navbar from "./Monthlytasks_navbar";
import arrears from "../../assets/images/dashboard_icon/arrears.svg";
import no_fee from "../../assets/images/dashboard_icon/no_fee.svg";
import struck_off from "../../assets/images/dashboard_icon/struck_off.svg";
import Concession from "../../assets/images/dashboard_icon/Concession.svg";
import imgMoney from "../../assets/images/icons/money.svg";
import clock from "../../assets/images/icons/clock.svg";
import { scrollToTop } from "../Shared/ScrollOnTop";
import config from "../../Config";

const fmtRs = (v) => {
  const n = Number(v);
  if (v == null || v === "" || Number.isNaN(n)) return "0";
  return n.toLocaleString(undefined, { maximumFractionDigits: 0 });
};

const MonthlyTasksDashboard = () => {
  const [AccessKey] = useState(localStorage.getItem("AccessKey"));
  const [UserID] = useState(localStorage.getItem("ID"));
  const [MemberType] = useState(localStorage.getItem("MemberType"));

  const [loadingDash, setLoadingDash] = useState(true);
  const [loadingMonths, setLoadingMonths] = useState(true);
  const [dData, setDashboardData] = useState({
    receiveableFee: 0,
    receivedSofar: 0,
    pendingFee: 0,
    concessionGiven: 0,
    arrearsOfPreviousMonth: 0,
    noofStruckOffthisMonth: 0,
    feeNotPaidLastMonth: 0,
  });
  const [startedMonths, setStartedMonths] = useState([]);
  const [totalStartedMonths, setTotalStartedMonths] = useState(0);

  useEffect(() => {
    document.title = "Monthly Task";
  }, []);

  useEffect(() => {
    let cancelled = false;
    setLoadingDash(true);
    axios({
      method: "post",
      url: config.base_url + "FeeSystem/GetDashboardData",
      headers: { "Content-Type": "application/json" },
      data: {
        AccessKey,
        UserID: UserID,
        MemberType: MemberType || "Admin",
        SessionID: parseInt(localStorage.getItem("DefaultSession"), 10) || 0,
      },
      timeout: 60000,
    })
      .then((res) => {
        if (cancelled) return;
        if (res.data?.status_code === 1) {
          setDashboardData(res.data);
        } else {
          setDashboardData({
            receiveableFee: 0,
            receivedSofar: 0,
            pendingFee: 0,
            concessionGiven: 0,
            arrearsOfPreviousMonth: 0,
            noofStruckOffthisMonth: 0,
            feeNotPaidLastMonth: 0,
          });
        }
      })
      .catch(() => {
        if (!cancelled) {
          setDashboardData({
            receiveableFee: 0,
            receivedSofar: 0,
            pendingFee: 0,
            concessionGiven: 0,
            arrearsOfPreviousMonth: 0,
            noofStruckOffthisMonth: 0,
            feeNotPaidLastMonth: 0,
          });
        }
      })
      .finally(() => {
        if (!cancelled) setLoadingDash(false);
      });
    return () => {
      cancelled = true;
    };
  }, [AccessKey, UserID, MemberType]);

  useEffect(() => {
    let cancelled = false;
    setLoadingMonths(true);
    axios({
      method: "post",
      url: config.base_url + "MonthlyTask/GetStartedMonths",
      headers: { "Content-Type": "application/json" },
      data: {
        AccessKey,
        UserID: UserID,
        MemberType: MemberType || "Admin",
        pageNo: 1,
        pageSize: 12,
        SchoolID: 1,
      },
      timeout: 60000,
    })
      .then((res) => {
        if (cancelled) return;
        if (res.data?.status_code === 1 && Array.isArray(res.data.ListofRecords)) {
          setStartedMonths(res.data.ListofRecords);
          setTotalStartedMonths(res.data.totalRecords || res.data.ListofRecords.length);
        } else {
          setStartedMonths([]);
          setTotalStartedMonths(0);
        }
      })
      .catch(() => {
        if (!cancelled) {
          setStartedMonths([]);
          setTotalStartedMonths(0);
        }
      })
      .finally(() => {
        if (!cancelled) setLoadingMonths(false);
      });
    return () => {
      cancelled = true;
    };
  }, [AccessKey, UserID, MemberType]);

  const startedOnDisplay = (raw) => {
    if (raw == null || raw === "") return "—";
    const m = moment(raw);
    return m.isValid() ? m.format(config.date_format) : String(raw);
  };

  return (
    <>
      <Monthly_navbar />
      <div className="page-head">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/Dashboard">Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Monthly Task
                  </li>
                </ol>
              </nav>
              <div className="page-title">Monthly Task</div>
            </div>
            <div className="col-md-6">
              <div className="page-right-actions d-flex flex-wrap justify-content-md-end gap-2">
                <Link
                  to="/MonthlyTasks/ManageMonth"
                  className="button button-white button-icon"
                  onClick={scrollToTop}
                >
                  Manage Month
                  <i className="ri-list-check"></i>
                </Link>
                <Link
                  to="/FeeSystem/FeeSystemDashboard"
                  className="button button-white button-icon"
                  onClick={scrollToTop}
                >
                  Fee dashboard
                  <i className="ri-pie-chart-line"></i>
                </Link>
                <Link
                  to="/FeeSystem/PrintChalanList"
                  className="button button-white button-icon"
                  onClick={scrollToTop}
                >
                  Print challans
                  <i className="ri-file-list-line"></i>
                </Link>
                <Link
                  to="/MonthlyTasks/FeeAbstractReport"
                  className="button button-white button-icon"
                  onClick={scrollToTop}
                >
                  Fee Abstract
                  <i className="ri-bar-chart-grouped-line"></i>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="page-content">
        <div className="container">
          <p className="text-muted small mb-3">
            Monthly posting uses the <strong>challan path</strong> (<code>tblChalanHead</code> +{" "}
            <code>tblADLedger</code>), same as the Fee System. Use <strong>Start New Month</strong> in
            the menu above to post a period; counts below match the Fee System dashboard for the{" "}
            <strong>current calendar month</strong>.
          </p>
          <div className="row gy-3 align-items-center">
            <div className="col-md-12">
              <div className="card m-card">
                <div className="card-body p-2">
                  <p className="text-center m-0">
                    <b>Challan posting snapshot (this month)</b>
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-3">
              <div className="card m-card">
                <div className="card-body text-center">
                  <img src={imgMoney} className="pb-3" alt="" />
                  <p className="m-2">Receivable on this month&apos;s challans</p>
                  <h4 className="m-2">
                    {loadingDash ? (
                      <Spinner animation="border" size="sm" />
                    ) : (
                      <>Rs.&nbsp;{fmtRs(dData.receiveableFee)}</>
                    )}
                  </h4>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-3">
              <div className="card m-card">
                <div className="card-body text-center">
                  <img src={clock} className="pb-3" alt="" />
                  <p className="m-2">Unpaid (pending) on this month&apos;s challans</p>
                  <h4 className="m-2">
                    {loadingDash ? (
                      <Spinner animation="border" size="sm" />
                    ) : (
                      <>Rs.&nbsp;{fmtRs(dData.pendingFee)}</>
                    )}
                  </h4>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-3">
              <div className="card">
                <div className="card-body text-center">
                  <img src={no_fee} className="pb-3" alt="" />
                  <p className="m-2">Students with at least one unpaid challan (last month)</p>
                  <h4 className="m-2">
                    {loadingDash ? (
                      <Spinner animation="border" size="sm" />
                    ) : (
                      Number(dData.feeNotPaidLastMonth) || 0
                    )}
                  </h4>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-3">
              <div className="card m-card">
                <div className="card-body text-center">
                  <img src={arrears} className="pb-3" alt="" />
                  <p className="m-2">Arrears on challan fee lines (this month)</p>
                  <h4 className="m-2">
                    {loadingDash ? (
                      <Spinner animation="border" size="sm" />
                    ) : (
                      <>Rs.&nbsp;{fmtRs(dData.arrearsOfPreviousMonth)}</>
                    )}
                  </h4>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-3">
              <div className="card m-card">
                <div className="card-body text-center">
                  <img src={Concession} className="pb-3" alt="" />
                  <p className="m-2">Concession (AD lines, this month&apos;s challans)</p>
                  <h4 className="m-2">
                    {loadingDash ? (
                      <Spinner animation="border" size="sm" />
                    ) : (
                      <>Rs.&nbsp;{fmtRs(dData.concessionGiven)}</>
                    )}
                  </h4>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-3">
              <div className="card m-card">
                <div className="card-body text-center">
                  <img src={struck_off} className="pb-3" alt="" />
                  <p className="m-2">Students struck off (this calendar month)</p>
                  <h4 className="m-2">
                    {loadingDash ? (
                      <Spinner animation="border" size="sm" />
                    ) : (
                      Number(dData.noofStruckOffthisMonth) || 0
                    )}
                  </h4>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-4">
              <div className="card m-card h-100">
                <div className="card-body text-center d-flex flex-column justify-content-center">
                  <p className="m-2">Compare fee heads across two challan months</p>
                  <Link
                    to="/MonthlyTasks/FeeAbstractReport"
                    className="button button-primary mt-2"
                    onClick={scrollToTop}
                  >
                    Fee Abstract report
                  </Link>
                </div>
              </div>
            </div>
            <div className="col-md-12">
              <div className="card">
                <div className="card-body">
                  <div className="d-flex flex-wrap justify-content-between align-items-center gap-2 mb-2">
                    <h5 className="mb-0">Started months (recent)</h5>
                    {totalStartedMonths > 12 ? (
                      <Link to="/MonthlyTasks/ManageMonth" onClick={scrollToTop} className="small">
                        View all ({totalStartedMonths})
                      </Link>
                    ) : null}
                  </div>
                  <table className="table table-theme table-condensed pb-md-0 mb-0">
                    <thead style={{ backgroundColor: "#F8F8F8" }}>
                      <tr>
                        <th>Month ID</th>
                        <th>Month</th>
                        <th>Year</th>
                        <th className="text-center">Started on</th>
                        <th className="text-center">Detail</th>
                      </tr>
                    </thead>
                    <tbody>
                      {loadingMonths ? (
                        <tr>
                          <td colSpan={5} className="text-center py-4">
                            <Spinner animation="border" role="status" />
                          </td>
                        </tr>
                      ) : startedMonths.length === 0 ? (
                        <tr>
                          <td colSpan={5} className="text-muted text-center py-3">
                            No started months yet. Use <strong>Start New Month</strong> to create one.
                          </td>
                        </tr>
                      ) : (
                        startedMonths.map((item, index) => {
                          const monthNum =
                            item.Month_Number ?? item.month_Number ?? item.month_number;
                          const yearVal =
                            item.Current_Year ?? item.current_Year ?? item.current_year;
                          const monthId = item.Month_ID ?? item.month_ID ?? item.month_id;
                          const started = item.Started_On ?? item.started_On ?? item.started_on;
                          return (
                            <tr key={monthId ?? `${monthNum}-${yearVal}-${index}`}>
                              <td>{monthId}</td>
                              <td>{monthNum}</td>
                              <td>{yearVal}</td>
                              <td className="text-center">{startedOnDisplay(started)}</td>
                              <td className="text-center">
                                <NavLink
                                  to={
                                    "/MonthlyTasks/MonthDetails/?Month=" +
                                    monthNum +
                                    "&Year=" +
                                    yearVal
                                  }
                                  className="blue"
                                  title="Month detail"
                                  onClick={scrollToTop}
                                >
                                  <i className="ri-pages-line"></i>
                                </NavLink>
                              </td>
                            </tr>
                          );
                        })
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MonthlyTasksDashboard;
